<template>
   <div class="grey_bg_footer">
		<footer class="footer_box w_container">
			<div class="footer_left_box">
				<div class="company_title">星工场（北京）营销策划有限公司</div>
				<div class="company_auther_box"> 
					<img class="footer_auther_icon" src="../../static/img/new/index/tel_icon.png" alt="">
					<span>合作电话：{{tel}}</span>
					</div>
					<div class="company_auther_box">
					<img class="footer_auther_icon" src="../../static/img/new/index/addr_icon.png" alt="">
					<span>地址：中国·北京市朝阳区广渠路3号竞园艺术中心15A-5</span>
					</div>
					<div class="company_copy_right">© 2017-2022 MSG 京ICP备14040511号-1</div>
			</div>
			<div class="footer_right_box">
				<div class="wx_code_box"> 
					<div class="wx_code_wrap">
						<img class="wx_code_img" src="../../static/img/new/index/gzh_img.jpg" alt="">
						</div>
					<div class="wx_tip_text">微信公众号</div>
				</div>
				<div class="wx_code_box">
					<div class="wx_code_wrap">
						<img class="wx_code_img" src="../../static/img/new/index/xcx_img.jpg" alt="">
					</div>
					<div class="wx_tip_text">微信小程序</div>
				</div>
			</div>
		</footer> 
	</div>
</template>

<script>
export default {
    name:'Footer',
	data(){
		return{
			tel:'',
		}
	},
	created(){
		this.get_tel();
	},
	methods:{
		async get_tel(){
			let tel = await this.axios.get("/Resource/kefu_tel",{});
			this.tel = tel.kefu_tel;
		}
	}
}
</script>
 
<style scoped>

/* footer 开始 */
.grey_footer_bg {
  width: 100%;
  background-color: #F6F9FB;
}
.footer_box {
	padding-top: 38px;
	padding-bottom: 23px;
	display: flex;
	justify-content: space-between;
}

.footer_left_box .company_title {
	font-size: 16px; 
	font-weight: 600;
	color: #555555;
	margin-bottom: 22px;
}

.footer_left_box .company_auther_box {
	margin-bottom: 8px;
}

.footer_left_box .company_auther_box .footer_auther_icon{
	width: 14px;
	height: 14px;
	margin-right: 9px;
	vertical-align: -3px;
}

.footer_left_box .company_auther_box span,
.footer_left_box .company_copy_right{
	font-size: 12px; 
	color: #8A8E93;
}

.footer_left_box .company_copy_right {
	 margin-top: 36px;
}
.footer_right_box {
	padding-right: 15px;
	display: flex;
}

.footer_right_box .wx_code_box:nth-child(1) {
	margin-right: 60px; 
}

.footer_right_box .wx_code_box{
	text-align: center;
}

.footer_right_box .wx_code_wrap{
	width: 130px;
	height: 130px;
	background: url('../../static/img/new/index/wx_code_wrap.png') no-repeat;
	background-size: 100% 100%; 
	display: flex;
    align-items: center;
    justify-content: center;
}

.footer_right_box .wx_code_img {
	width: 110px;
	height: 110px;
}

.footer_right_box .wx_tip_text {
	margin-top: 8px;
	font-size: 12px; 
	color: #8A8E93;
}
 
/* footer 结束 */
  
</style>



// WEBPACK FOOTER //
// src/components/footer.vue